import React, {useCallback, useMemo} from 'react';
import type {Maybe} from '../../graphql';
import {useSchemas} from '../hooks/user-schemas';
import Intercept from './easy-form/Intercept';
import Fields from './easy-form/fields';
import type {preValidationTransform} from './easy-form/types';

interface IProps {
  tag: string;
  required?: boolean;
  props: {className: string | undefined; disabled?: boolean};
  disabled?: boolean;
  label?: Maybe<string>;
}

export default function PhoneField({
  tag,
  required,
  props,
  label,
}: IProps): JSX.Element {
  const generalSchemas = useSchemas();

  const schema = useMemo(() => {
    const {phone} = generalSchemas;
    return phone(required);
  }, [generalSchemas, required]);

  const transform: preValidationTransform = useCallback(
    (filtered) => {
      const str = (filtered as any)?.[tag]?.toString().replace(/\D/g, ``) || ``;
      return str;
    },
    [tag],
  );

  const mask = useCallback((input: string): string => {
    return input.replace(/[^+\-.\(\) \d]/g, ``);
  }, []);

  return (
    <Intercept tag={tag} outputTransform={transform} skipTag>
      <Fields.Text
        label={label}
        tag={tag}
        required={required}
        schema={schema}
        props={props}
        mask={mask}
      />
    </Intercept>
  );
}
